export default {"src":"/_next/static/media/video-doc.ab203cbb.svg","height":40,"width":40};